/**
 * The models offered for draft generation and for the journalistic reformat pass.
 *
 * ONE list, rendered twice. The Generation Model and Reformat Model selects in
 * BriefGenerationSettingsModal used to hold two hand-maintained copies of the
 * same four <option> tags, which is precisely how the two drift apart — an
 * editor picks a reformat model the generation select has never heard of, or a
 * model is retired from one list and left live in the other.
 *
 * Every `value` here must be mappable by `phaseConfigFromModelString`
 * (backend/utils/modelSelection.js). An id this list offers but that function
 * does not know is not an error the user ever sees: the backend silently falls
 * back to gpt-5 and the draft is written by a model nobody chose.
 *
 * `requiresClaude` entries are hidden unless the backend reports
 * CLAUDE_MODELS_AVAILABLE (i.e. ANTHROPIC_API_KEY is set on the webapp host).
 */
export const BRIEF_MODEL_OPTIONS = Object.freeze([
  { value: 'gpt-5', label: 'GPT-5' },
  { value: 'gemini-2.5-flash', label: 'Gemini 2.5 Flash' },
  { value: 'gemini-2.5-pro', label: 'Gemini 2.5 Pro' },
  { value: 'gpt-4o', label: 'GPT-4o' },
  { value: 'claude-sonnet-5', label: 'Claude Sonnet 5', requiresClaude: true },
  { value: 'claude-opus-5-5', label: 'Claude Opus 5.5', requiresClaude: true },
]);

/**
 * @param {boolean} claudeAvailable value of CLAUDE_MODELS_AVAILABLE
 * @returns {Array<{value: string, label: string}>} options safe to render
 */
export function availableBriefModelOptions(claudeAvailable) {
  return BRIEF_MODEL_OPTIONS.filter((o) => !o.requiresClaude || claudeAvailable);
}
